// extracted by mini-css-extract-plugin
export default {"modal":"CopyTemplateModal-module__modal__VBdHm","content":"CopyTemplateModal-module__content__TfMhM","alert":"CopyTemplateModal-module__alert__W0lwk"};